var React = require('react');

function Time (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-1273 -1176)"},[React.createElement("circle",{"cx":"7.5","cy":"7.5","r":"7.5","transform":"translate(1273.5 1176.5)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1","key":0}),React.createElement("line",{"y2":"5","transform":"translate(1281.5 1179.5)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1","key":1}),React.createElement("line",{"x1":"3","y1":"3","transform":"translate(1281.5 1184.5)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1","key":2})]));
}

Time.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Time;

Time.default = Time;
